import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export { GetTranslation, GetFallbackLanguages, UpdateTranslation };

function GetTranslation(contractNumber, versionNumber, editionNumber, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}/translations`,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function UpdateTranslation(contractNumber, versionNumber, editionNumber, translationObject, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractNumber}/versions/${versionNumber}/editions/${editionNumber}/translations`,
      translationObject,
      headers
    )
    .then((response) => {
      onSuccess(response);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetFallbackLanguages(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + `/infrastructure/language/language/supportedlanguage`, headers)
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}
